import { Box, Typography } from '@mui/material';

export const formatRichText = (text: string) => {
  const parts = text.split(/(<mark>.*?<\/mark>|<(?:strong|b)>.*?<\/(?:strong|b)>)/g);
  let cursor = 0;

  return parts.map((part) => {
    if (!part) {
      return null;
    }

    const key = `${cursor}-${part}`;
    cursor += part.length;

    if (part.startsWith('<mark>') && part.endsWith('</mark>')) {
      return (
        <Typography key={key} component="span" variant="inherit" className="primary">
          {part.replace(/<\/?mark>/g, '')}
        </Typography>
      );
    }

    if (
      (part.startsWith('<strong>') && part.endsWith('</strong>')) ||
      (part.startsWith('<b>') && part.endsWith('</b>'))
    ) {
      return (
        <Typography key={key} component="span" variant="inherit" className="semi-bold" sx={{ color: 'inherit' }}>
          {part.replace(/<\/?(strong|b)>/g, '')}
        </Typography>
      );
    }

    return (
      <Box key={key} component="span" sx={{ whiteSpace: 'pre-line' }}>
        {part}
      </Box>
    );
  });
};
